import "../node_modules/react/jsx-runtime.js";
import { j as s } from "./jsx-runtime2.js";
const r = s.exports.Fragment, x = s.exports.jsx, e = s.exports.jsxs;
export {
  r as Fragment,
  x as jsx,
  e as jsxs
};
//# sourceMappingURL=jsx-runtime.js.map
